<template>
  <div class="pincode-cnt">
    <header class="inner-header">
      <!-- <div class="logo-icon">
        <img src="../assets/images/logo.svg" />
      </div> -->

      <div class="audience-counter">
        <p>{{$t('Total People')}}</p>
        <span class="total-val" v-if="pincodeDetail">{{
          pincodeDetail.userCount
        }}</span>
        <span class="total-val" v-if="!pincodeDetail">000,00</span>
      </div>
    </header>
    <div class="mid-cnt">
      <div class="pincode-container">
        <h3>{{$t('On which Pincodes do you want to run your ad?')}}</h3>
        <p>{{$t('You can enter a pincode to see how many people your ads will reach!')}}</p>
        <div class="field-row">
          <div class="pin-area">
            <ul id="chiplist" class="chiplisting">
              <li v-for="(pin, index) in pincodesList" :key="index">
                <span class="text-label">{{ pin }}</span>
                <span class="remove-pin" @click="removePincode(index)"> </span>
              </li>
            </ul>
            <input
              type="number"
              id="text_val"
              placeholder="Enter pincode"
              autofocus
              @keyup="(event) => handlePincode(event.target.value)"
            />
          </div>
          <span class="error-msg" v-if="errMessage">{{ errMessage }}</span>
        </div>
      </div>
    </div>
    <div class="footer">
      <!-- <span class="note-msg">लोगो तक अपनी ad पहुंचाने के लिए</span> -->
      <span
        :class="pincodeDetail ? 'ftr-btn' : 'ftr-btn'"
        @click="handleRedirect"
      >
        <!-- disable -->
        {{$t('Proceed')}}
      </span>
    </div>
    <loadingIcon v-if="loading" />
    <Toaster :dataValue="toasterData" />
  </div>
</template>

<script>
import Toaster from '../components/Toaster';
import { SessionHelper } from '../utils/session';
import loadingIcon from '../components/icons/loadingIcon';
export default {
  name: 'Pincode',
  components: {
    Toaster,
    loadingIcon,
  },
  mounted() {},
  data() {
    return {
      pincodesList: [],
      errMessage: '',
      pincodeDetail: null,
      loading: false,
      toasterData: {},
      disable: false,
    };
  },
  methods: {
    handlePincode(value) {
      let regx = /^(\d{6})$/;
      if (regx.test(value)) {
        this.pincodesList.push(value);
        this.errMessage = '';
        document.getElementById('text_val').value = '';
        if (this.pincodesList.length) {
          this.handlePincodeCovers();
        }
      } else {
        this.errMessage = 'Please input valid pincode of 6 digit number';
        if(value === ''){
          this.errMessage = ''
        }
      }
    },
    removePincode(index) {
      this.pincodesList.splice(index, 1);
      this.handlePincodeCovers();
    },
    handleRedirect() {
      if (this.pincodeDetail && this.pincodeDetail.userCount) {
        this.$router.push(
          `/create-ad-form?intent=${this.$route.query.intent}&MediaType=${this.$route.query.MediaType}`
        );
      } else {
        this.toasterData = {
          status: true,
          msg: 'Please enter pincode',
          timeoutMs: '5000',
          color: '#ff6600',
        };
      }
    },
    pincodeDispatch() {
      this.$store
        .dispatch({
          type: 'PincodeSupport',
          payload: this.pincodesList.join(','),
        })
        .then((data) => {
          if (data.httpStatus) {
            this.disable = false;
            this.loading = false;
            if (data.httpStatus === 200) {
              this.pincodeDetail = data.data;
              console.log('==this.pincodeDetail.pincodes=', this.pincodeDetail.pincodes)
              this.$store.commit('PincodeList', this.pincodeDetail.pincodes);
            }
            if (data.httpStatus === 404) {
              this.pincodeDetail = null;
              this.pincodesList = [];
              document.getElementById('text_val').value = '';
            }

            // this.toasterData = {
            //   status: true,
            //   msg: data.message,
            //   timeoutMs: "5000",
            //   color: "#ff6600",
            // };
          }
        });
    },
    handlePincodeCovers() {
      this.loading = true;
      this.disable = true;
      this.pincodeDispatch();
    },
  },
};
</script>
